'use strict';

import tracker from "../tracking/tracker.js";
import debug from "../qa/debug";
import {CINEMAMODE} from "./dimensions";

export default (tileListView, tiles, cinemaView, isExpandable) => {
    const TARGET_TILE_INDEX_UNINITIALIZED = -1;
    const IMAGE_CONTAINER_PADDING_WIDTH = 4;
    const IMAGE_CONTAINER_PADDING_HEIGHT = 8;
    const tileListController = {};
    let dragging = false;
    let dragStartIndex = tileListView.firstVisibleTileIndex();
    let lastTargetTileIndex = TARGET_TILE_INDEX_UNINITIALIZED;
    let firstLoadedImgHeight;

    const init = () => {
        tiles.forEach((tile) => tile.registerOnClickHandler(() => tracker.trackClick(cinemaView, tile)))
    };

    tileListController.onScrollEventDone = () => {
        const dragEndIndex = tileListView.firstVisibleTileIndex();
        if (dragEndIndex > dragStartIndex) {
            tileListController.trackScrollRight();
        } else if (dragEndIndex < dragStartIndex) {
            tileListController.trackScrollLeft();
        }
        dragging = false;
    };

    tileListController.debounce = (callback, millisAfterLastCall) => {
        let timeout;
        const executeCallback = () => {
            timeout = null;
            callback();
        };
        return () => {
            clearTimeout(timeout);
            timeout = setTimeout(executeCallback, millisAfterLastCall);
        };
    };

    tileListController.cinemaMode = () => {
        return tileListView.cinemaMode();
    }

    tileListController.scrollLeft = (startedOrFinishedScrollingCallback) => {
        const tilesPerPage = tileListView.fullyVisibleTilesPerPage();
        const firstVisibleTileIndex = tileListView.firstVisibleTileIndex();
        const targetTileIndex = Math.max(0, firstVisibleTileIndex - tilesPerPage);
        scrollTo(targetTileIndex, startedOrFinishedScrollingCallback);
    };

    tileListController.trackScrollLeft = () => {
        tracker.trackScrollPrevious(cinemaView, tileListController.getAllVisibleTilesWithHalfVisibleTiles());
    };

    tileListController.trackScrollRight = () => {
        tracker.trackScrollNext(cinemaView, tileListController.getAllVisibleTilesWithHalfVisibleTiles());
    };

    tileListController.scrollRight = (startedOrFinishedScrollingCallback) => {
        const tilesPerPage = tileListView.fullyVisibleTilesPerPage();
        const firstVisibleTileIndex = tileListView.firstVisibleTileIndex();
        const indexOfFirstTileOfLastPage = tiles.length - tilesPerPage;
        const targetTileIndex = Math.min(firstVisibleTileIndex + tilesPerPage, indexOfFirstTileOfLastPage);
        scrollTo(targetTileIndex, startedOrFinishedScrollingCallback);
    };

    const scrollTo = (targetTileIndex, startedOrFinishedScrollingCallback) => {
        /*                                                            */
        if (targetTileIndex !== lastTargetTileIndex) {
            lastTargetTileIndex = targetTileIndex;
            tileListView.scrollTo(targetTileIndex, startedOrFinishedScrollingCallback);
        }
        debug.log({targetTileIndex,startedOrFinishedScrollingCallback})
    };

    tileListController.isAtLeftBorder = () => {
        return tileListView.isAtLeftBorder();
    };

    tileListController.isAtRightBorder = () => {
        return tileListView.isAtRightBorder();
    };

    tileListController.tileCount = () => {
        return tiles.length;
    };

    tileListController.getFirstVisibleTileIndex = tileListView.firstVisibleTileIndex;

    tileListController.getAllVisibleTiles = () => {
        const capacity = tileListView.fullyVisibleTilesPerPage();
        const firstVisibleTileIndex = tileListView.firstVisibleTileIndex();

        return tiles.slice(firstVisibleTileIndex, firstVisibleTileIndex + capacity);
    };

    tileListController.getAllVisibleTilesWithHalfVisibleTiles = () => {
        return tiles.filter((tile) => tile.isWithinContainerViewport());
    };

    tileListController.getAllTrackingTiles = () => {

    }

    tileListController.registerScrollHandler = () => {
        tileListView.registerScrollHandler(scrollHandler);
    };

    const setImageContainerHeight = (height) => {
        if (!firstLoadedImgHeight) {
            firstLoadedImgHeight = height;
        }
        tiles.forEach((tile) => {
            tile.setImageContainerHeight(firstLoadedImgHeight + IMAGE_CONTAINER_PADDING_HEIGHT);
        });
        return firstLoadedImgHeight;
    };

    tileListController.updateTiles = () => {
        const tileWidth = tileListView.tileWidthPx();
        tiles.forEach((tile, tileIndex) => {
            if(tileListController.cinemaMode() !== CINEMAMODE.REDESIGN) {
                const adjustedWidth = makeUpForMissingPaddingInFirstAndLastChild(tileIndex, tileWidth);
                tile.update(adjustedWidth, false);
            } else {
                tile.update(tileWidth, true);
            }
        });

        return tileListController.loadImages();
    };

    tileListController.loadImages = () => {
        if (tileListController.cinemaMode() === CINEMAMODE.REDESIGN) {
            let loadVisibleTiles = tileListController.getAllVisibleTilesWithHalfVisibleTiles().map((tile) => tile.lazyLoad());
            return Promise.all(loadVisibleTiles)
                .then(allTiles => allTiles[allTiles.length-1])
        }

        const visibleImagePromises = tileListController.getAllVisibleTilesWithHalfVisibleTiles()
            .map((tile) => tile.lazyLoad());
        return Promise.race(visibleImagePromises)
            .then(setImageContainerHeight);
    }


    const makeUpForMissingPaddingInFirstAndLastChild = (tileIndex, tileWidth) => {
        if (!isExpandable && (tileIndex === 0 || tileIndex === (tiles.length - 1))) {
            return tileWidth - IMAGE_CONTAINER_PADDING_WIDTH;
        }
        return tileWidth;
    };

    const delayInMilliseconds = 150;
    const debounceFunction = tileListController.debounce(tileListController.onScrollEventDone, delayInMilliseconds);
    const scrollHandler = () => {
        debounceFunction();

        tileListController.loadImages();

        if (!dragging) {
            dragStartIndex = tileListView.firstVisibleTileIndex();
            dragging = true;
        }
    };

    init();

    return tileListController;
};
